import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const LearningPathBasicInfoComponent = ({
    selectLMSLearningPaths, handleInnerFormChange,LmsCoursesList,learningPathCategory,difficultyLevel
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Title"
                            labelField="Title"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Title'
                                );
                            }}
                            type="text"
                            value={selectLMSLearningPaths?.Title}
                        />

                        <InputContainer
                            label="Duration"
                            labelField="Duration"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Duration'
                                );
                            }}
                            type="text"
                            value={selectLMSLearningPaths?.Duration}
                        />

                        <InputContainer
                            label="Category"
                            labelField="Text"
                            list={learningPathCategory}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Category'
                                );
                            }}
                            optionName="Choose Courses"
                            type="select"
                            valueField="Text"
                            value={selectLMSLearningPaths?.Category}
                        />

                        <InputContainer
                            label="Level"
                            labelField="Text"
                            list={difficultyLevel}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Level'
                                );
                            }}
                            optionName="Choose Parent Topic"
                            type="select"
                            valueField="Text"
                            value={selectLMSLearningPaths?.Level}
                        />

                        <InputContainer
                            label="Display Order"
                            labelField="DisplayOrder"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DisplayOrder'
                                );
                            }}
                            type="number"
                            value={selectLMSLearningPaths?.DisplayOrder}
                        />

                        <InputContainer
                            label="Published"
                            name="IsPublished"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event, 'IsPublished');
                            }}
                            type="checkbox"
                            value={selectLMSLearningPaths?.IsPublished}
                        />

                        <div className='col-span-full'>
                            <InputContainer
                                label="Description"
                                name="Description"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Description'
                                    );
                                }}
                                type="text" // Rich text editor for description
                                value={selectLMSLearningPaths?.Description}
                            />

                            {/* <InputContainer
                                label="Mapped Topic"
                                labelField="Title"
                                list={TopicsList}
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'MappedTopicIds'
                                    );
                                }}
                                optionName="Choose Parent Topic"
                                type="select"
                                valueField="Id"
                                value={selectLMSLearningPaths?.MappedTopicIds}
                            /> */}

                            <InputContainer
                                label="Mapped Course"
                                labelField="Description"
                                list={LmsCoursesList}
                                onValueChange={(newValue: any) => {
                                    const accessTypeValues: any = newValue.map((option: any) => option?.value || '')

                                    handleInnerFormChange(accessTypeValues, 'MappedCourseIds');
                                }}

                                type="multiselect"
                                value={selectLMSLearningPaths?.MappedCourseIds}
                                valueField="CourseId"
                            />
                        </div>
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    );
}

export default LearningPathBasicInfoComponent;
